/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deleting_Your_Account_PermanenInputs */

const en_deleting_your_account_permanen = /** @type {(inputs: Deleting_Your_Account_PermanenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting your account permanently wipes all storefronts, listings, and payout histories.                                                     This process is irreversible.`)
};

const es_deleting_your_account_permanen = /** @type {(inputs: Deleting_Your_Account_PermanenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar tu cuenta borrará permanentemente todas las tiendas, anuncios e historiales de pagos. Este proceso es irreversible.`)
};

const fr_deleting_your_account_permanen = /** @type {(inputs: Deleting_Your_Account_PermanenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La suppression de votre compte effacera de façon permanente toutes les vitrines, annonces et historiques de paiements. Ce processus est irréversible.`)
};

const de_deleting_your_account_permanen = /** @type {(inputs: Deleting_Your_Account_PermanenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Löschen deines Kontos löscht dauerhaft alle Storefronts, Inserate und Auszahlungshistorien. Dieser Vorgang ist unumkehrbar.`)
};

const ja_deleting_your_account_permanen = /** @type {(inputs: Deleting_Your_Account_PermanenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを完全に削除すると、すべてのストアフロント、出品、支払い履歴が消去されます。この操作は取り消せません。`)
};

const zh_deleting_your_account_permanen = /** @type {(inputs: Deleting_Your_Account_PermanenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`永久删除您的账号将抹除所有店铺、商品和提现历史记录。此过程不可逆转。`)
};

const ar_deleting_your_account_permanen = /** @type {(inputs: Deleting_Your_Account_PermanenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يؤدي حذف حسابك إلى مسح جميع واجهات المتاجر والإعلانات وسجلات الدفع بشكل دائم. لا يمكن التراجع عن هذه العملية.`)
};

const id_deleting_your_account_permanen = /** @type {(inputs: Deleting_Your_Account_PermanenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghapus akun Anda secara permanen akan menghilangkan semua etalase, listing, dan riwayat pembayaran. Proses ini tidak dapat dibatalkan.`)
};

const it_deleting_your_account_permanen = /** @type {(inputs: Deleting_Your_Account_PermanenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminare il tuo account cancellerà permanentemente tutte le vetrine, gli annunci e le cronologie dei pagamenti. Questo processo è irreversibile.`)
};

const ru_deleting_your_account_permanen = /** @type {(inputs: Deleting_Your_Account_PermanenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При безвозвратном удалении вашего аккаунта удаляются все витрины, объявления и история выплат. Этот процесс необратим.`)
};

const pt_deleting_your_account_permanen = /** @type {(inputs: Deleting_Your_Account_PermanenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir sua conta limpará permanentemente todas as vitrines, anúncios e históricos de pagamentos. Este processo é irreversível.`)
};

const ko_deleting_your_account_permanen = /** @type {(inputs: Deleting_Your_Account_PermanenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정을 삭제하면 모든 스토어프론트, 상품, 정산 내역이 영구적으로 지워집니다. 이 작업은 되돌릴 수 없습니다.`)
};

/**
* | output |
* | --- |
* | "Deleting your account permanently wipes all storefronts, listings, and payout histories. This process is irreversible." |
*
* @param {Deleting_Your_Account_PermanenInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const deleting_your_account_permanen = /** @type {((inputs?: Deleting_Your_Account_PermanenInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deleting_Your_Account_PermanenInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deleting_your_account_permanen(inputs)
	if (locale === "es") return es_deleting_your_account_permanen(inputs)
	if (locale === "fr") return fr_deleting_your_account_permanen(inputs)
	if (locale === "de") return de_deleting_your_account_permanen(inputs)
	if (locale === "ja") return ja_deleting_your_account_permanen(inputs)
	if (locale === "zh") return zh_deleting_your_account_permanen(inputs)
	if (locale === "ar") return ar_deleting_your_account_permanen(inputs)
	if (locale === "id") return id_deleting_your_account_permanen(inputs)
	if (locale === "it") return it_deleting_your_account_permanen(inputs)
	if (locale === "ru") return ru_deleting_your_account_permanen(inputs)
	if (locale === "pt") return pt_deleting_your_account_permanen(inputs)
	return ko_deleting_your_account_permanen(inputs)
});